<script>
import DataProvider from './DataProvider.vue';
import DogRepository from '../../js/repository/DogRepository.js';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        dogId: {
            type: String,
            required: true,
        },
        callback: {
            type: Function,
            required: false,
            default: () => {},
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: DogRepository.findMemberRelations,
                params: [this.dogId],
                reload: this.load,
                callback: this.callback,
            },
            scopedSlots: this.$scopedSlots,
        });
    },
};
</script>
